export const color_collection_boutique = "#1f448d";
export const color_collection_cycling = "#333333";
export const color_collection_excellent = "#5e2f7e";
export const color_collection_fam_fun = "#ed2924";
export const color_collection_secrets = "#00bfd4";
export const color_collection_selections = "#f66e20";
export const color_collection_ski_in_ski_out = "#056464";
export const color_collection_villages = "#147a58";
export const color_collection_xperience = "#ed2924";
export const color_collection_atlantis = "#fe6400";
export const color_collection_totally = "#ff6600";
export const color_collection_primavera = "#00b49d";
export const color_palette_grey_50 = "#FFFFFF";
export const color_palette_grey_100 = "#FBF9F6";
export const color_palette_grey_200 = "#EDEBE7";
export const color_palette_grey_300 = "#D9D6D1";
export const color_palette_grey_400 = "#B5B0AB";
export const color_palette_grey_500 = "#928D8B";
export const color_palette_grey_700 = "#494141";
export const color_palette_grey_800 = "#362F2F";
export const color_palette_grey_900 = "#000000";
export const color_palette_primary_300 = "#FFCACF";
export const color_palette_primary_500 = "#FF333F";
export const color_palette_primary_700 = "#EA2934";
export const color_palette_green_300 = "#A6E2CF";
export const color_palette_green_500 = "#21B788";
export const color_palette_green_700 = "#198966";
export const color_palette_red_300 = "#FACAC9";
export const color_palette_red_500 = "#ED2924";
export const color_palette_red_700 = "#CE231F";
export const color_palette_yellow_300 = "#FDEFB8";
export const color_palette_yellow_500 = "#F4BE15";
export const color_palette_yellow_700 = "#FF9933";
export const color_palette_blue_300 = "#A7DEF9";
export const color_palette_blue_500 = "#008FCB";
export const color_palette_blue_700 = "#006996";
export const color_palette_transparent_white_75 = "rgba(255, 255, 255, 0.75)";
export const color_palette_transparent_black_16 = "rgba(0, 0, 0, 0.16)";
export const color_palette_transparent_black_25 = "rgba(0, 0, 0, 0.25)";
export const color_palette_transparent_black_50 = "rgba(0, 0, 0, 0.5)";
export const color_palette_transparent_black_80 = "rgba(0, 0, 0, 0.80)";
export const color_palette_transparent_red_20 = "rgba(255, 51, 63, 0.2)";
export const color_palette_transparent_sand_50 = "rgba(231, 224, 215, 0.5)";
export const color_semantic_bg = "#FFFFFF";
export const color_semantic_bg_disabled = "#EDEBE7";
export const color_semantic_bg_error = "#ED2924";
export const color_semantic_bg_error_hover = "#CE231F";
export const color_semantic_bg_error_subdued = "#FACAC9";
export const color_semantic_bg_info = "#008FCB";
export const color_semantic_bg_info_disabled = "#A7DEF9";
export const color_semantic_bg_info_subdued = "#A7DEF9";
export const color_semantic_bg_input_strong = "#928D8B";
export const color_semantic_bg_input_strong_hover = "#494141";
export const color_semantic_bg_input_strong_disabled = "#EDEBE7";
export const color_semantic_bg_inverse = "#362F2F";
export const color_semantic_bg_inverse_hover = "#000000";
export const color_semantic_bg_inverse_disabled = "#928D8B";
export const color_semantic_bg_primary = "#FF333F";
export const color_semantic_bg_primary_hover = "#EA2934";
export const color_semantic_bg_primary_disabled = "#D9D6D1";
export const color_semantic_bg_success = "#21B788";
export const color_semantic_bg_success_hover = "#198966";
export const color_semantic_bg_success_disabled = "#A6E2CF";
export const color_semantic_bg_success_subdued = "#A6E2CF";
export const color_semantic_bg_warning = "#F4BE15";
export const color_semantic_bg_warning_subdued = "#FDEFB8";
export const color_semantic_bg_strong = "#E7E0D7";
export const color_semantic_bg_strong_hover = "#837868";
export const color_semantic_bg_strong_disabled = "#F3EFEB";
export const color_semantic_bg_subdued = "#FBF9F6";
export const color_semantic_bg_subdued_hover = "#F3EFEB";
export const color_semantic_border = "#D9D6D1";
export const color_semantic_border_disabled = "#D9D6D1";
export const color_semantic_border_hover = "#928D8B";
export const color_semantic_border_active = "#928D8B";
export const color_semantic_border_error = "#ED2924";
export const color_semantic_border_error_hover = "#CE231F";
export const color_semantic_border_primary = "#FF333F";
export const color_semantic_border_primary_disabled = "#FFCACF";
export const color_semantic_border_primary_hover = "#EA2934";
export const color_semantic_border_strong = "#837868";
export const color_semantic_border_strong_hover = "#63533D";
export const color_semantic_border_strong_disabled = "#F3EFEB";
export const color_semantic_border_strong_active = "#362F2F";
export const color_semantic_border_subdued = "#EDEBE7";
export const color_semantic_border_info = "#008FCB";
export const color_semantic_border_success = "#21B788";
export const color_semantic_border_success_disabled = "#A6E2CF";
export const color_semantic_border_success_hover = "#198966";
export const color_semantic_border_warning = "#F4BE15";
export const color_semantic_icon = "#362F2F";
export const color_semantic_icon_disabled = "#D9D6D1";
export const color_semantic_icon_hover = "#000000";
export const color_semantic_icon_on_color = "#FFFFFF";
export const color_semantic_icon_strong = "#837868";
export const color_semantic_icon_subdued = "#928D8B";
export const color_semantic_icon_success = "#21B788";
export const color_semantic_text = "#362F2F";
export const color_semantic_text_error = "#ED2924";
export const color_semantic_text_on_color = "#FFFFFF";
export const color_semantic_text_disabled = "#D9D6D1";
export const color_semantic_text_placeholder = "#928D8B";
export const color_semantic_text_primary = "#FF333F";
export const color_semantic_text_primary_disabled = "#FFCACF";
export const color_semantic_text_primary_hover = "#EA2934";
export const color_semantic_text_strong = "#837868";
export const color_semantic_text_subdued = "#928D8B";
export const color_semantic_text_subdued_hover = "#000000";
export const font_family_primary = "var(--font-secondary, 'Branding Sunweb')";
export const font_family_secondary = "var(--font-primary, 'General Sans')";
export const font_line_height_xs = 1;
export const font_line_height_sm = 1.1;
export const font_line_height_md = 1.2;
export const font_line_height_lg = 1.5;
export const font_size_2xs = "11px";
export const font_size_xs = "13px";
export const font_size_sm = "15px";
export const font_size_md = "16px";
export const font_size_lg = "18px";
export const font_size_xl = "24px";
export const font_size_2xl = "28px";
export const font_size_3xl = "32px";
export const font_size_4xl = "40px";
export const font_weight_bold = 700;
export const font_weight_semibold = 600;
export const font_weight_medium = 500;
export const typography_heading_2xl_typeface = "var(--font-secondary, 'Branding Sunweb')";
export const typography_heading_2xl_size = "40px";
export const typography_heading_2xl_line_height = 1;
export const typography_heading_2xl_style = "normal";
export const typography_heading_2xl_weight = 700;
export const typography_heading_2xl_letter_spacing = "0";
export const typography_heading_xl_typeface = "var(--font-secondary, 'Branding Sunweb')";
export const typography_heading_xl_size = "32px";
export const typography_heading_xl_line_height = 1;
export const typography_heading_xl_style = "normal";
export const typography_heading_xl_weight = 700;
export const typography_heading_xl_letter_spacing = "-0.32px";
export const typography_heading_lg_typeface = "var(--font-secondary, 'Branding Sunweb')";
export const typography_heading_lg_size = "28px";
export const typography_heading_lg_line_height = 1;
export const typography_heading_lg_style = "normal";
export const typography_heading_lg_weight = 700;
export const typography_heading_lg_letter_spacing = "-0.28px";
export const typography_heading_md_typeface = "var(--font-secondary, 'Branding Sunweb')";
export const typography_heading_md_size = "24px";
export const typography_heading_md_line_height = 1.1;
export const typography_heading_md_style = "normal";
export const typography_heading_md_weight = 700;
export const typography_heading_md_letter_spacing = "-0.24px";
export const typography_body_lg_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_lg_size = "18px";
export const typography_body_lg_line_height = 1.5;
export const typography_body_lg_style = "normal";
export const typography_body_lg_weight = 500;
export const typography_body_lg_letter_spacing = "0";
export const typography_body_lg_bold_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_lg_bold_size = "18px";
export const typography_body_lg_bold_line_height = 1.5;
export const typography_body_lg_bold_style = "normal";
export const typography_body_lg_bold_weight = 600;
export const typography_body_lg_bold_letter_spacing = "0";
export const typography_body_md_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_md_size = "15px";
export const typography_body_md_line_height = 1.5;
export const typography_body_md_style = "normal";
export const typography_body_md_weight = 500;
export const typography_body_md_letter_spacing = "0.3px";
export const typography_body_md_bold_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_md_bold_size = "15px";
export const typography_body_md_bold_line_height = 1.5;
export const typography_body_md_bold_style = "normal";
export const typography_body_md_bold_weight = 600;
export const typography_body_md_bold_letter_spacing = "0.3px";
export const typography_body_md_caption_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_md_caption_size = "15px";
export const typography_body_md_caption_line_height = 1.1;
export const typography_body_md_caption_style = "normal";
export const typography_body_md_caption_weight = 600;
export const typography_body_md_caption_letter_spacing = "0.3px";
export const typography_body_sm_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_sm_size = "13px";
export const typography_body_sm_line_height = 1.2;
export const typography_body_sm_style = "normal";
export const typography_body_sm_weight = 500;
export const typography_body_sm_letter_spacing = "0.26px";
export const typography_body_sm_bold_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_sm_bold_size = "13px";
export const typography_body_sm_bold_line_height = 1.2;
export const typography_body_sm_bold_style = "normal";
export const typography_body_sm_bold_weight = 600;
export const typography_body_sm_bold_letter_spacing = "0.26px";
export const typography_body_xs_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_xs_size = "11px";
export const typography_body_xs_line_height = 1.2;
export const typography_body_xs_style = "normal";
export const typography_body_xs_weight = 500;
export const typography_body_xs_letter_spacing = "0.33px";
export const typography_body_xs_bold_typeface = "var(--font-primary, 'General Sans')";
export const typography_body_xs_bold_size = "11px";
export const typography_body_xs_bold_line_height = 1.2;
export const typography_body_xs_bold_style = "normal";
export const typography_body_xs_bold_weight = 600;
export const typography_body_xs_bold_letter_spacing = "0.33px";
export const typography_label_typeface = "var(--font-primary, 'General Sans')";
export const typography_label_size = "16px";
export const typography_label_line_height = 1.5;
export const typography_label_style = "normal";
export const typography_label_weight = 600;
export const typography_label_letter_spacing = "0";
export const typography_label_thin_typeface = "var(--font-primary, 'General Sans')";
export const typography_label_thin_size = "16px";
export const typography_label_thin_line_height = 1.5;
export const typography_label_thin_style = "normal";
export const typography_label_thin_weight = 500;
export const typography_label_thin_letter_spacing = "0";
export const theme_color_neutral_100 = "#FBF9F6";
export const theme_color_neutral_200 = "#FAF7F3";
export const theme_color_neutral_300 = "#F3EFEB";
export const theme_color_neutral_400 = "#E7E0D7";
export const theme_color_neutral_500 = "#837868";
export const theme_color_neutral_700 = "#63533D";
export const theme_color_neutral_800 = "#362F2F";
export const breakpoint_mobile = "480px";
export const breakpoint_tablet = "600px";
export const breakpoint_desktop_sm = "840px";
export const breakpoint_desktop_md = "960px";
export const breakpoint_desktop_lg = "1280px";
export const breakpoint_desktop_xl = "1440px";
export const mq_mobile = "(min-width: 480px)";
export const mq_tablet = "(min-width: 600px)";
export const mq_desktop_sm = "(min-width: 840px)";
export const mq_desktop_md = "(min-width: 960px)";
export const mq_desktop_lg = "(min-width: 1280px)";
export const mq_desktop_xl = "(min-width: 1440px)";
export const radius_none = 0;
export const radius_medium = "4px";
export const radius_large = "8px";
export const radius_extra_large = "16px";
export const radius_rounded = "1000px";
export const shadow_md_top = "0px -2px 6px 0px rgba(0, 0, 0, 0.08)";
export const shadow_md_bottom = " 0px 2px 6px 0px rgba(0, 0, 0, 0.08)";
export const shadow_lg_top = "0px -2px 8px 0px rgba(0, 0, 0, 0.16)";
export const shadow_lg_bottom = "0px 2px 8px 0px rgba(0, 0, 0, 0.16)";
export const shadow_input = "0px 2px 6px 0px rgba(0, 0, 0, 0.08) inset";
export const shadow_input_focus_grey = "0px 0px 0px 3px rgba(0, 0, 0, 0.20), 0px 2px 6px 0px rgba(0, 0, 0, 0.08) inset";
export const shadow_focus_red = "0px 0px 0px 3px rgba(255, 51, 63, 0.2)";
export const shadow_focus_grey = "0px 0px 0px 3px rgba(0, 0, 0, 0.25)";
export const spacing_none = "0";
export const spacing_2xs = "4px";
export const spacing_xs = "8px";
export const spacing_sm = "12px";
export const spacing_md = "16px";
export const spacing_lg = "24px";
export const spacing_xl = "32px";
export const spacing_2xl = "40px";
export const spacing_3xl = "48px";
export const spacing_4xl = "64px";
export const spacing_5xl = "80px";
